import * as React from 'react';

const EditSmallIcon = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M17.7455 3.55559C17.3383 3.14841 16.6781 3.14841 16.271 3.55559C16.271 3.55559 5.9491 13.8774 5.58046 14.2461C5.21183 14.6147 3 21.2502 3 21.2502C3 21.2502 9.63548 19.0384 10.0041 18.6697C10.3728 18.3011 20.6946 7.97925 20.6946 7.97925C21.1018 7.57206 21.1018 6.91188 20.6946 6.50469L17.7455 3.55559Z'
			/>
		</svg>
	);
};

export default EditSmallIcon;
